import React from 'react';
import PreviewCompatibleImage from '../Utils/PreviewCompatibleImage';

import './insight-blocks.scss';

function renderBody(block, i) {
  const body = [];

  if (block.body != null) {
    body.push(
      <p key={++i} className="body-copy">{block.body}</p>
    );
  }

  return body;
}

function renderBlocks(blocks) {
  const allBlocksHTML = [];
  
  blocks.forEach((block, i) => {
    const blockHTML = [];
    if (block.headline || block.body) {
      blockHTML.push(
        <div key={i} className="insight-blocks__copy-blocks__block">
          {renderImage(block.image)}
          {block.headline ? <h3 className={`headline ${block.headline.length < 7 ? "xlarge" : ''}`}>{block.headline}</h3> : ''}
          {renderBody(block, i)}
          {block.headline2 ? <h3 className={`headline2 ${block.headline2.length < 7 ? "xlarge" : ''}`}>{block.headline2}</h3> : ''}
        </div>
      )
    }

    allBlocksHTML.push(blockHTML);
  })

  return allBlocksHTML;
}

function renderImage(imageData) {
  if(imageData) {
    return (
      <PreviewCompatibleImage
        customClassName={ "icon" }
        imageInfo={imageData}
        alt="icon"
      />
    )
  }
}

const insightBlocks = ({ blocks, headline }) => {
  return (
    <>
      {headline ? <p className="insight-blocks__headline">{headline}</p> : ''}
      <div className="insight-blocks__copy-blocks">
        {renderBlocks(blocks)}
      </div>
    </>
  )
}

export default insightBlocks
